module.exports = __webpack_public_path__ + "media/images/pages/sample_brands/brand-invision-fd3cb2a9509bfae99bace4e15f328663.png";